import React from "react";

interface MobileAlertBannerProps {
    severity?: "info" | "warning" | "error" | "success";
    icon?: string;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const SEVERITY_CONFIG = {
    info: {
        bg: "#F0F9FF",
        border: "#BAE6FD",
        iconColor: "#0084D1",
        textColor: "#0369A1",
        defaultIcon: "pi pi-info-circle",
    },
    warning: {
        bg: "#FFFBEB",
        border: "#FDE68A",
        iconColor: "#D97706",
        textColor: "#B45309",
        defaultIcon: "pi pi-exclamation-triangle",
    },
    error: {
        bg: "#FEF2F2",
        border: "#FECACA",
        iconColor: "#DC2626",
        textColor: "#991B1B",
        defaultIcon: "pi pi-times-circle",
    },
    success: {
        bg: "#ECFDF5",
        border: "#A7F3D0",
        iconColor: "#059669",
        textColor: "#065F46",
        defaultIcon: "pi pi-check-circle",
    },
};

const MobileAlertBanner: React.FC<MobileAlertBannerProps> = ({
    severity = "info",
    icon,
    children,
    className = "",
    style = {},
}) => {
    const config = SEVERITY_CONFIG[severity];
    const displayIcon = icon ?? config.defaultIcon;

    return (
        <div
            className={`p-3 border-round-lg flex align-items-start gap-2 ${className}`}
            style={{
                backgroundColor: config.bg,
                border: `1px solid ${config.border}`,
                ...style,
            }}
        >
            <i
                className={`${displayIcon} text-base flex-shrink-0 mt-1`}
                style={{ color: config.iconColor }}
            />
            <div
                className="text-xs"
                style={{
                    color: config.textColor,
                    lineHeight: "1.4",
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default MobileAlertBanner;